// `apps/web` Sentry adapter — re-exports the shared `@barel/telemetry/web`
// surface plus a typed `bootSentry()` helper that reads Vite env vars and
// short-circuits to a no-op when `VITE_SENTRY_DSN_WEB` is empty.
//
// Hard rule from the build prompt: the integration must NOT crash, NOT call
// any 3rd-party network, and NOT throw when no DSN is provided.
//
// Wave 9 baseline: `tracesSampleRate: 0.2`, `replaysSessionSampleRate: 0.1`,
// `replaysOnErrorSampleRate: 1.0`. Replay is privacy-tight (mask all text +
// inputs, block media). The redaction allowlist runs in `beforeSend`.

import { initSentryWeb, SentryErrorBoundary, setSentryUser } from '@barel/telemetry/web';

export interface BootSentryOptions {
  dsn?: string | undefined;
  env?: string | undefined;
  release?: string | undefined;
  tracesSampleRate?: number;
}

/**
 * Initialise Sentry from the supplied options. Returns `true` when a client
 * was created, `false` when we no-op'd (DSN missing). Safe to call from
 * `main.tsx` regardless of environment configuration.
 */
export function bootSentry(options: BootSentryOptions = {}): boolean {
  return initSentryWeb({
    dsn: options.dsn,
    env: options.env,
    release: options.release,
    tracesSampleRate: options.tracesSampleRate,
  });
}

/** Re-exported for `<App>` so callers don't reach into the telemetry barrel. */
export { SentryErrorBoundary, setSentryUser };
